import { Event } from "@live-chair-health/lch-core";

export const checkAttendance = (eventItem: Event, id: string) => {
  return eventItem?.attendees?.includes(id);
};
